import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { GiftCard } from './gift-card'
import { GiftCardSerializer } from './gift-card.serializer'

@Injectable()
export class GiftCardService extends ResourceService<GiftCard> {
  constructor(
    private http: HttpClient,
    private giftCardSerializer: GiftCardSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/gift-cards-templates`,
      giftCardSerializer
    )
  }
}
